export const testimonials = [
  {
    name: 'Jennifer M.',
    role: 'Sports Massage Therapist, 34 — Running Clinic',
    initials: 'JM',
    quote:
      'I see a lot of runners between 6 and 9 p.m., and I used to rebuild every session from memory. The planning tools in Volume 01 and the 30-minute running example gave me a clear structure: goal, priority regions, timing. My appointments feel calmer and far better prepared.',
  },
  {
    name: 'Michael R.',
    role: 'Licensed Massage Therapist, 41 — Former Rugby Player',
    initials: 'MR',
    quote:
      'After 12 years in practice I thought I knew every lower-body technique. What I was missing was organization. Volume 02 lays out positioning, contact and sequence for each region, so I can switch from hamstrings to calves without losing flow or wasting minutes.',
  },
  {
    name: 'Ashley S.',
    role: 'Massage Therapist, 29 — Triathlon & Cycling Clubs',
    initials: 'AS',
    quote:
      'I work race weekends, and Volume 04 changed how I prepare. Short pre-event sessions and post-event comfort sequences are all organized. The Sports Event Preparation Toolkit alone saved me from forgetting half my supplies at the last half-marathon.',
  },
  {
    name: 'David P.',
    role: 'Manual Therapy Professional, 46 — Youth Soccer Academy',
    initials: 'DP',
    quote:
      'With thirty players and limited time, I need ready-to-adapt plans. The soccer sessions in Volume 05 in 30-, 45- and 60-minute formats let me choose quickly and still adjust to each athlete. It is a reference I open every single week.',
  },
  {
    name: 'Sarah B.',
    role: 'Clinic Owner & Sports Massage Practitioner, 38',
    initials: 'SB',
    quote:
      'The bonuses were worth it on their own. I now use the client forms for every new athlete, the follow-up templates for reminders and rebooking, and the body protection toolkit helped me rethink my table height after long days. Everything finally lives in one system.',
  },
]
